import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {CompetitionNavLiveState} The Competition Nav Live state.
 */
export const liveSelector = (state) => state.competitionNavV2.live;
